import { masterV2Api } from "@/apis/interceptor"
import { IPaginationParamV2, IResponse, ISimper, ISimperQr, ISimperResponse } from "@/types"

export const simperService = {
  getSimperRecords: async (params: IPaginationParamV2): Promise<IResponse<ISimperResponse>> => {
    const response = await masterV2Api.get<IResponse<ISimperResponse>>("/v1/simper-records", { params })
    return response.data
  },

  getSimperBySimperNumber: async (simperNumber: string): Promise<IResponse<ISimper>> => {
    const response = await masterV2Api.get<IResponse<ISimper>>(`/v1/simper-records/admin/${simperNumber}`)
    return response.data
  },

  getSimperQrBySimperNumber: async (simperNumber: string): Promise<IResponse<ISimperQr>> => {
    const response = await masterV2Api.get<IResponse<ISimperQr>>(`/v1/simper-records/qr/${simperNumber}`)
    return response.data
  },
}
